var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#22313f;stroke-miterlimit:10;stroke-width:1.5px;}.c{fill:#22313f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-558 -4391)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(558 4391)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(495 4328)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M80,72a8,8,0,1,0-8,8A8,8,0,0,0,80,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M181.6,182.667h-4.533A1.068,1.068,0,0,1,176,181.6v-4.533A1.068,1.068,0,0,1,177.067,176H181.6a1.068,1.068,0,0,1,1.067,1.067V181.6A1.068,1.068,0,0,1,181.6,182.667Z",
    transform: "translate(-107.333 -107.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stop-icon.2ba8e0cc0aa68068e2144150cc0efcc6.svg";
export { ForwardRef as ReactComponent };